import { useTranslation } from "react-i18next";
import PageShell, { Breadcrumb } from "@/components/feature/PageShell";

export default function Research() {
  const { t } = useTranslation();

  const researchProjectKeys = [0, 1, 2, 3, 4, 5];
  const publicationKeys = [0, 1, 2, 3];

  return (
    <PageShell>
      <section className="relative pt-24 pb-20 bg-gradient-to-b from-primary-800 to-primary-700 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20scientific%20research%20pattern%20with%20interconnected%20data%20nodes%20and%20network%20lines%2C%20deep%20burgundy%20background%2C%20modern%20data%20visualization%20aesthetic%2C%20academic%20research%20texture%2C%20warm%20subtle%20glow%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=research-hero-01&orientation=landscape')] bg-cover bg-center opacity-15"></div>
        <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8">
          <Breadcrumb items={[{ label: t("research.title") }]} />
          <div className="mt-6 max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              {t("research.title")}
            </h1>
            <p className="mt-4 text-lg text-background-100/80 leading-relaxed">
              {t("research.subtitle")}
            </p>
          </div>
        </div>
      </section>

      {/* Research Projects */}
      <section className="py-16 md:py-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-2">{t("research.projects")}</h2>
          <p className="text-foreground-500 mb-8">{t("research.projects.desc")}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {researchProjectKeys.map((i) => (
              <div key={i} className="bg-background-100 rounded-lg p-6 flex flex-col">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs font-medium bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">{t(`research.projects.${i}.category`)}</span>
                  <span className="text-xs text-foreground-400">2025-2026</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">{t(`research.projects.${i}.title`)}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{t(`research.projects.${i}.abstract`)}</p>
                <div className="flex flex-wrap gap-1.5 mt-4 pt-4 border-t border-background-200">
                  {[0, 1, 2].map((j) => (
                    <span key={j} className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">{t(`research.projects.${i}.kw${j}`)}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Publications */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-2">{t("research.publications")}</h2>
          <p className="text-foreground-500 mb-8">{t("research.publications.desc")}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {publicationKeys.map((i) => (
              <div key={i} className="bg-background-50 rounded-lg p-6 flex gap-4">
                <div className="flex-shrink-0 w-12 h-16 flex items-center justify-center rounded bg-accent-100 text-accent-700">
                  <i className="ri-book-open-line text-xl"></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-medium bg-accent-100 text-accent-700 px-2 py-0.5 rounded whitespace-nowrap">{t(`research.pub.${i}.type`)}</span>
                    <span className="text-xs text-foreground-400">{t(`research.pub.${i}.date`)}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-1">{t(`research.pub.${i}.title`)}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t(`research.pub.${i}.desc`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}